<template>
    <!-- 服务 -->
    <div>
        <myheader :messages="parentMessage"></myheader>
        <!--  -->
        <div class="aboutopcomm w1750 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
            <div class="mk wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                <div class="h">定制不仅仅是设计  更是对品质的追求</div>
                <div class="p">一个好的策划方案无法满足每个人对个性的追求，倾听您的需求，做您满意的产品，打造好的产品体验。</div>
                <div class="moreboxmax">
                    <div class="a a1" @click="kefuclick"><i>在线咨询</i></div> 
                      <div class="a a2" @click="baojia">获取报价</div>
                </div>
            </div>
        </div>
        <div class="serveboxmaxone w1366 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s">
            <div class="li cur">WEB开发</div>
            <div class="li">微信开发</div>
            <div class="li">APP开发</div>
            <div class="li">数据可视化</div>
            <div class="li">云产品</div>
            <div class="li">模版小程序</div>
        </div>
        <div class="serveboxmaxlist w1750">
            <div class="wli wli1 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">
                <div class="toop">
                    <div class="text wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                        <div class="h">WEB开发</div>
                        <div class="m">Web应用程序是一种可以通过Web访问的应用程序，程序的最大好处是用户很容易访问应用程序，用户只需要有浏览器即可，不需要再安装其他软件。</div>
                        <div class="p">Web开发是一个涉及多个技术和领域的复杂过程，主要关注于创建和维护网站或网络应用程序。这个过程通常包括前端开发、后端开发以及数据库管理等环节</div>
                        <div class="a" @click="kefuclick">在线咨询</div>
                    </div>
                    <div class="img wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                        <img src="../assets/22.png" alt="" class="img1">
                        <img src="../assets/23.png" alt="" class="img2">
                    </div>
                </div>
                <div class="boot">
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/images/w25.png" alt=""></div>
                        <div class="ter">
                            <div class="h">高端网站建设</div>
                            <div class="p">高端网站建设注重展现企业或个人的独特形象，通过独特的设计风格和个性化的内容布局，使网站在众多同类网站中脱颖而出。</div>
                        </div>
                    </div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/images/w26.png" alt=""></div>
                        <div class="ter">
                            <div class="h">H5</div>
                            <div class="p">H5页面能够利用HTML5的新特性，如视频和音频标签、Canvas绘图、SVG矢量图形等，实现更丰富的内容展示和交互效果。这使得H5网页在视觉上更加吸引人，能够为用户提供更好的浏览体验。</div>
                        </div>
                    </div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/images/w27.png" alt=""></div>
                        <div class="ter">
                            <div class="h">应用系统</div>
                            <div class="p">Web应用系统是一种通过Web浏览器进行访问和交互的软件系统，它利用Web技术（如HTML、CSS、JavaScript等）和服务器技术（如Node.js、Java、PHP等）实现各种功能。Web应用系统通常采用B/S（浏览器/服务器）架构。</div>
                        </div>
                    </div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/images/w28.png" alt=""></div>
                        <div class="ter">
                            <div class="h">可视化数据看版</div>
                            <div class="p">可视化数据看板是一种综合性的数据展示工具，它通过图表、图像、文本等多种形式将大量数据呈现出来，使业务人员能够迅速了解数据背后的业务状况</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="wli wli2 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                <div class="toop">
                    <div class="text wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                        <div class="h">微信开发</div>
                        <div class="m">微信开发，即微信公众平台开发，是一种将企业信息、服务、活动等内容通过微信网页方式展现的技术实现。用户通过简单的设置，就能生成微信网站，形成线上线下微信互动营销方式。微信开发不仅限于微信公众平台，还包括小程序开发等多个方面.</div>
                        <div class="a" @click="kefuclick">在线咨询</div>
                    </div>
                    <div class="img wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                        <img src="../assets/24.png" alt="" class="img1">
                        <img src="../assets/25.png" alt="" class="img2">
                    </div>
                </div>
                <div class="boot">
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/images/w29.png" alt=""></div>
                        <div class="ter">
                            <div class="h">公众号</div>
                            <div class="p">微信公众号开发是一个涉及多个技术领域的综合性工程，主要包括注册公众号、了解公众号管理页面、使用必备开发者工具、细读开发者文档以及开发流程重点解析等步骤</div>
                        </div>
                    </div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/images/w30.png" alt=""></div>
                        <div class="ter">
                            <div class="h">小程序</div>
                            <div class="p">微信小程序是一种不需要下载安装即可使用的应用，它实现了应用“触手可及”的梦想，用户扫一扫或者搜一下即可打开应用，体现了“用完即走”的理念。</div>
                        </div>
                    </div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/images/w31.png" alt=""></div>
                        <div class="ter">
                            <div class="h">企业微信</div>
                            <div class="p">企业微信是腾讯微信团队为企业打造的企业通讯与办公工具，它集成了多种功能，旨在提升企业的沟通效率和管理水平。</div>
                        </div>
                    </div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/images/w32.png" alt=""></div>
                        <div class="ter">
                            <div class="h">其他</div>
                            <div class="p">基于微信开发的其他相关业务，以及抖音小程序，支付宝小程序，百度小程序等相关开发。</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="wli wli3 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                <div class="toop">
                    <div class="text wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                        <div class="h">APP开发</div>
                        <div class="m">专注打造有品质的app开发产品，提供一体化的互联网+技术解决方案，让您的项目从构念到产品快速启动、轻松落地！明确目标群体诉求,解决用户痛点,以合适的视觉表现和流畅的用户体验，体现出您的核心竞争力。</div>
                        <div class="a" @click="kefuclick">在线咨询</div>
                    </div>
                    <div class="img wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                        <img src="../assets/26.png" alt="" class="img1">
                        <img src="../assets/27.png" alt="" class="img2">
                    </div>
                </div>
                <div class="boot">
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/images/w33.png" alt=""></div>
                        <div class="ter">
                            <div class="h">Android</div>
                            <div class="p">用户量最多的手机操作系统<br/>推广相对容易<br/>系统开发性高</div>
                        </div>
                    </div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/images/w34.png" alt=""></div>
                        <div class="ter">
                            <div class="h">IOS</div>
                            <div class="p">应用发布统一也唯一<br/>系统机型少，适配性最优</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="wli wli4 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                <div class="toop">
                    <div class="text wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                        <div class="h">数据可视化</div>
                        <div class="m">随着社会的迅猛发展，信息化可视化需求也急剧增长，特别是一些监控中心、指挥中心、调度中心等重要场所，数据大屏可视化系统已经成为信息可视化不可或缺的展示平台。在科幻影视剧里，经常有看到大数据可视化系统的应用，其实，数据大屏可视化系统并不少见，是非常常见的大数据应用。帮助各行业领域管理者从多个方面提升智能化决策能力。</div>
                    </div>
                    <div class="img wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                        <img src="../assets/28.png" alt="" class="img1">
                    </div>
                </div>
            </div>
            <div class="wli wli5 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                <div class="toop">
                    <div class="text wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                        <div class="h">云产品</div>
                        <div class="m">云产品是指基于云计算技术的产品，通过互联网提供各种计算资源和服务，如存储、计算、数据库、人工智能等。这些服务使得用户可以轻松地获取所需资源，而无需在本地进行大量的硬件和软件投入。</div>
                        <div class="mine">
                            <i><img src="../assets/images/w15.png" alt="" /></i>
                            <i><img src="../assets/images/w16.png" alt="" /></i>
                            <i><img src="../assets/images/w17.png" alt="" /></i>
                            <i><img src="../assets/images/w19.png" alt="" /></i>
                        </div>
                    </div>
                </div>
                <div class="boot">
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/images/w35.png" alt=""></div>
                        <div class="ter">
                            <div class="h">域名</div>
                            <div class="p">是互联网的一项核心服务，它能够将域名和IP地址相互映射，从而使用户能够更方便地访问互联网，提供代注册维护等服务。</div>
                        </div>
                    </div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/images/w36.png" alt=""></div>
                        <div class="ter">
                            <div class="h">服务器</div>
                            <div class="p">供可弹性的云虚拟机服务，用户可以在云端创建、启动、停止、重启服务器，并根据使用量计费。</div>
                        </div>
                    </div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/images/w37.png" alt=""></div>
                        <div class="ter">
                            <div class="h">SSL安全证书</div>
                            <div class="p">SSL安全证书，又称SSL证书或服务器证书，是数字证书的一种，类似于驾驶证、护照和营业执照的电子副本。它是遵守SSL协议，由受信任的数字证书颁发机构（CA）在验证服务器身份后颁发的，具有服务器身份验证和数据传输加密功能</div>
                        </div>
                    </div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/images/w38.png" alt=""></div>
                        <div class="ter">
                            <div class="h">安全运维</div>
                            <div class="p">确保信息系统安全的一系列活动，旨在保护信息系统免受攻击、破坏和泄露，并确保系统稳定运行。</div>
                        </div>
                    </div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/images/w39.png" alt=""></div>
                        <div class="ter">
                            <div class="h">AI工具</div>
                            <div class="p">利用人工智能技术开发的各类软件和应用，如AI 内容生成等工具接入。</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="wli wli6 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                <div class="toop">
                    <div class="text wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                        <div class="h">小程序模板市场</div>
                        <div class="m">
                            有众小程序除支持对接微信小程序外，还包含抖音小程序和支付宝小程序，强大的底层能力，让用户实现多平台一键发布。此外为企业提供的还并非是千篇一律的模块和功能，而是最大限度的让企业可以自由组合、创作独一无二、适合自身业务场景的个性化定制专属小程序。 
                        </div>
                        <div class="a" @click="kefuclick">在线咨询</div>
                    </div>
                    <div class="img wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                        <img src="../assets/29.png" alt="" class="img1">
                    </div>
                </div>
                <div class="boot wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                    <div class="li" v-for="(item,index) in moreserbox" :key="index" @click="serveclick(item.id)">
                        <div class="m"><img :src="item.pic" alt=""></div>
                        <div class="ter">
                            <div class="h">{{item.title}}</div>
                            <div class="p">{{item.apply}}</div>
                        </div>
                    </div>
                    <!-- <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/img/ph22.png" alt=""></div>
                        <div class="ter">
                            <div class="h">智慧门店</div>
                            <div class="p">针对于传统连锁店所开发的小程序。帮助商家全面接入互联网，实现线上线下结合，提供更多优质的服务</div>
                        </div>
                    </div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/img/18.png" alt=""></div>
                        <div class="ter">
                            <div class="h">智慧餐厅</div>
                            <div class="p">类似于美团、大众点评，具有排队、预约、点餐及点评功能，扫码即可点餐，无需服务员参与，下单自动出票</div>
                        </div>
                    </div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/img/icon20.png" alt=""></div>
                        <div class="ter">
                            <div class="h">智慧政务</div>
                            <div class="p">帮助政府进行政府形象展示，推进阳光政务，方便政民互动，建立统一的政府信息公开平台。</div>
                        </div>
                    </div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/img/16.png" alt=""></div>
                        <div class="ter">
                            <div class="h">企业展示</div>
                            <div class="p">利用小程序来展示产品、案例、宣传企业文化、发布资讯等，快速创建一个小程序官网，通过二维码扫描即可进入。</div>
                        </div>
                    </div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="m"><img src="../assets/img/img24.png" alt=""></div>
                        <div class="ter">
                            <div class="h">房产中介</div>
                            <div class="p">房产中介模块主要是用于线下的房产中介门店。为这些机构提供了线上的房源信息以及经纪人展示的一个平台。</div>
                        </div>
                    </div> -->
                </div>
                <div class="more wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><div @click="moclick">查看更多行业模版</div></div>
            </div>
        </div>
        <!--   -->
        <myfooter></myfooter>
        <!--  -->
        <upsform :upunm="baoMessage" @updateEvent="handleUpdate"></upsform>
    </div>
</template>

<script>
    import myfooter from './footer.vue'
    import myheader from './header.vue'
    import upsform from './upform.vue'
    
    export default {
        data() {
            return {
                parentMessage: 1,
                baoMessage: false,
                moreserbox: []
            }
        },
        created() {
            this.getserveindex()
        },
        methods: {
            handleUpdate(updatedValue) {
                this.baoMessage = updatedValue; // 更新父组件的Prop值
            },
            baojia() {
                this.baoMessage = true;
            },
            moclick(){
                this.$router.push('/mould').catch(err=>{ })
                window.scrollTo(0,0);
            },
            kefuclick(){
                const url = 'https://p.qiao.baidu.com/cps4/chatIndex?siteToken=fa6b3d5361002f77431328216553694d&speedLogId=16216501944184228_1621650194418_93941&eid=25401671&reqParam=%7B%22from%22%3A0%2C%22sid%22%3A%22-100%22%2C%22tid%22%3A%22-1%22%2C%22ttype%22%3A1%2C%22siteId%22%3A%2211856238%22%2C%22userId%22%3A%2225401671%22%2C%22pageId%22%3A0%7D';
                // window.location.href = url;
                window.open(url)
            },
            async getserveindex(){
                var url = `/api/smallapp/recommend`
                const { data: res } = await this.$http.post(url)
                
                console.log(res)
                this.moreserbox = res.data
                
                if(res.code !== 200){
                    return alert('获取失败！')
                }

            },
            serveclick(id){
                const { href } = this.$router.resolve({
                    path: '/moulddata',
                    query: { id }
                })
                window.open(href, '_blank', 'noopener')
            },
        },
        components: {
        	myfooter, myheader, upsform
        }
    }
</script>

<style>
.serveboxmaxone{ padding: 0.4rem 0; display: flex; justify-content: space-between;}
.serveboxmaxone .li{ border-radius: 0.1rem; transition: all 0.5s; cursor: pointer; min-width: 1.8rem; padding: 0 0.1rem; font-size: 0.2rem; font-weight: bold; line-height: 1rem; background: #FAFAFF; text-align: center;}
.serveboxmaxone .li.cur{ box-shadow: 0px 2px 11px 0px rgba(0,0,0,0.06);}
.serveboxmaxone .li:hover{ background: hsla(208,97%,57%,0.10); color: #2699FC;}

.serveboxmaxlist .wli + .wli{ margin-top: 0.8rem;}
/* .serveboxmaxlist .wli{ border-radius: 0.2rem; background: #F8F8FF;}
.serveboxmaxlist .wli2{ background: #F3FFFA;}
.serveboxmaxlist .wli3{ background: #FFFCF6;}
.serveboxmaxlist .wli4{ background: #F6FFFF;}
.serveboxmaxlist .wli5{ background: #FFF6F9;}
.serveboxmaxlist .wli6{ background: #F6F8FA;} */
.serveboxmaxlist .wli .toop{ border-radius: 0.2rem; background: #F8F8FF; min-height: 6.8rem; position: relative;}
.serveboxmaxlist .wli2 .toop{ background: #F3FFFA;}
.serveboxmaxlist .wli3 .toop{ background: #FFFCF6;}
.serveboxmaxlist .wli4 .toop{ background: #F6FFFF;}
.serveboxmaxlist .wli5 .toop{ background: #FFF6F9;}
.serveboxmaxlist .wli6 .toop{ background: #F6F8FA;} 
.serveboxmaxlist .wli .toop .text{ width: 5.84rem; padding: 1rem 0 0 2.35rem;}
.serveboxmaxlist .wli .toop .text .h{ font-size: 0.62rem; line-height: 0.82rem; font-weight: bold; margin-bottom: 0.1rem;}
.serveboxmaxlist .wli .toop .text .m{ font-size: 0.2rem; line-height: 0.28rem; font-weight: bold; color: #050505; margin-bottom: 0.1rem;}
.serveboxmaxlist .wli .toop .text .p{ font-size: 0.18rem; line-height: 0.26rem; color: #676767; margin-right: 1.2rem; margin-bottom: 1.5rem;}
.serveboxmaxlist .wli .toop .text .a{ transition: all 0.5s; width: 1.6rem; height: 0.6rem; text-align: center; line-height: 0.6rem; font-size: 0.16rem; color: #fff; cursor: pointer; background: #2699FC; border-radius: 0.04rem;}
.serveboxmaxlist .wli .toop .text .a:hover{ background: hsla(208,97%,57%,0.10); color: #2699FC;}
.serveboxmaxlist .wli .toop{ display: flex; justify-content: space-between; align-items: flex-start;}
.serveboxmaxlist .wli .toop .img{ /* width: 7.4rem; */ position: relative;}
.serveboxmaxlist .wli .toop .img .img1{ display: block; width: 7.46rem; position: absolute; top: 0.57rem; right: 1.86rem; z-index: 2;}
.serveboxmaxlist .wli .toop .img .img2{ display: block; width: 5.46rem; position: absolute; top: 2.69rem; right: 1.41rem;}
.serveboxmaxlist .wli .boot{ display: flex; justify-content: space-between; flex-wrap: wrap; padding: 0.75rem 2.35rem 0 2.35rem;}
.serveboxmaxlist .wli .boot .li{ width: 5.74rem; display: flex; justify-content: space-between; align-items: flex-start; margin-top: 1.2rem;}
.serveboxmaxlist .wli .boot .li:first-child,
.serveboxmaxlist .wli .boot .li:nth-child(2){ margin-top: 0;}
.serveboxmaxlist .wli .boot .li .ter{ width: calc(100% - 0.84rem);}
.serveboxmaxlist .wli .boot .li .m{ display: flex; justify-content: center; align-items: center; width: 0.7rem; height: 0.7rem; border-radius: 0.14rem; background: #fff; box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.09);}
.serveboxmaxlist .wli .boot .li .m img{ display: block; max-width: 100%; max-height: 100%;}
.serveboxmaxlist .wli .boot .li .p{ font-size: 0.16rem; line-height: 0.22rem; color: #9A9A9A;}
.serveboxmaxlist .wli .boot .li .h{ font-size: 0.25rem; line-height: 0.36rem; font-weight: bold; margin-bottom: 0.08rem; padding-top: 0.02rem;}
.serveboxmaxlist .wli2 .toop .text{ width: 4.4rem;}
.serveboxmaxlist .wli2 .toop .text .m{ font-size: 0.18rem; line-height: 0.26rem; color: #050505; margin-bottom: 1rem;}
.serveboxmaxlist .wli2 .toop .img{ /* width: 6.94rem; */}
.serveboxmaxlist .wli2 .toop .img .img1{ width: 4.04rem; position: absolute; top: 0.28rem; right: 4.77rem; z-index: 2;}
.serveboxmaxlist .wli2 .toop .img .img2{ width: 5.89rem; top: 2.01rem; right: 2.21rem;}
.serveboxmaxlist .wli2 .toop .text .a{ background: #77D0AB;}
.serveboxmaxlist .wli2 .toop .text .a:hover{ color: #77D0AB; background: hsla(155,49%,64%,0.10);}
.serveboxmaxlist .wli2 .boot .li:first-child,
.serveboxmaxlist .wli2 .boot .li:nth-child(2){ margin-top: 0;}
/* .serveboxmaxlist .wli3{ min-height: 9.74rem;} */
.serveboxmaxlist .wli3 .toop .text{ width: 4.4rem;}
.serveboxmaxlist .wli3 .toop .text .m{ font-size: 0.18rem; line-height: 0.26rem; color: #050505; margin-bottom: 1rem;}
.serveboxmaxlist .wli3 .toop .text .a{ background: #F4BE52;}
.serveboxmaxlist .wli3 .toop .text .a:hover{ color: #F4BE52; background: hsla(40,88%,64%,0.10);}
.serveboxmaxlist .wli3 .toop .img .img1{ width: 1.64rem; position: absolute; top: 0.87rem; right: 5.42rem; z-index: 2;}
.serveboxmaxlist .wli3 .toop .img .img2{ width: 1.64rem; top: 1.64rem; right: 3.53rem;}
/* .serveboxmaxlist .wli3 .boot{ display: block; padding: 0.6rem 0 1rem 0.4rem;}
.serveboxmaxlist .wli3 .boot .li{ margin: 0;}
.serveboxmaxlist .wli3 .boot .li + .li{ margin-top: 0.9rem;} */
.serveboxmaxlist .wli4{ padding: 0.7rem 3rem 0.94rem 2.38rem; background: #F6FFFF; border-radius: 0.2rem; min-height: unset;}
.serveboxmaxlist .wli4 .toop{ display: block;}
.serveboxmaxlist .wli4 .toop .text{ width: auto; padding: 0; margin-bottom: 0.9rem;}
.serveboxmaxlist .wli4 .toop .text .m{ font-size: 0.18rem; line-height: 0.26rem;}
.serveboxmaxlist .wli4 .toop .img{ width: auto;}
.serveboxmaxlist .wli4 .toop .img .img1{ padding: 0; width: 8.55rem; margin: auto; position: relative; top: auto; right: auto; left: auto;}
.serveboxmaxlist .wli5{ padding: 0.7rem 2.1rem 1rem 2.38rem; display: flex; justify-content: space-between; background: #FFF6F9; border-radius: 0.2rem;}
.serveboxmaxlist .wli5 .toop .text{ width: 3.57rem; padding: 0;}
.serveboxmaxlist .wli5 .toop .text .m{ font-size: 0.18rem; line-height: 0.26rem;}
.serveboxmaxlist .wli5 .toop .mine{ padding: 1.8rem 0 0 0.72rem;}
.serveboxmaxlist .wli5 .toop .mine i{ margin-bottom: 0.2rem; display: flex; justify-content: center; align-items: center; width: 1.54rem; height: 0.6rem; background: #fff; border: 1px solid #FFE9ED;}
.serveboxmaxlist .wli5 .toop .mine i img{ display: block; max-width: 100%; max-height: 100%;}
.serveboxmaxlist .wli5 .boot{ width: 8.2rem; padding: 0;}
.serveboxmaxlist .wli5 .boot .li{ width: 3.35rem; margin-top: 0.8rem; display: block;}
.serveboxmaxlist .wli5 .boot .li .m{ margin: 0 0 0.16rem 0;}
.serveboxmaxlist .wli5 .boot .li .ter{ width: auto;}
.serveboxmaxlist .wli6{ /* padding: 0.7rem 0.26rem 0.9rem 0.4rem; */}
.serveboxmaxlist .wli6 .toop{ background: #F6F8FA; padding: 0.8rem 2.14rem 1.14rem 2.18rem; min-height: unset;}
.serveboxmaxlist .wli6 .toop .text{ width: 5.2rem; padding: 0.42rem 0 0 0;}
.serveboxmaxlist .wli6 .toop .img{ width: 7.34rem; padding: 0}
.serveboxmaxlist .wli6 .toop .img img.img1{ display: block; width: 100%; position: relative; top: auto; right: auto;}
.serveboxmaxlist .wli6 .toop .text .h{ margin-bottom: 0.3rem;}
.serveboxmaxlist .wli6 .toop .text .m{ font-size: 0.18rem; line-height: 0.26rem; color: #050505;}
.serveboxmaxlist .wli6 .boot{ /* padding: 0.45rem 0.6rem 0 0.4rem; */}
.serveboxmaxlist .wli6 .boot .li{ width: 3.63rem; margin-top: 0.45rem; display: block; cursor: pointer;}
.serveboxmaxlist .wli6 .boot .li:nth-child(3){ margin-top: 0;}
.serveboxmaxlist .wli6 .more{ display: flex; justify-content: center; margin: 0.8rem 0 0 0;}
.serveboxmaxlist .wli6 .more div{ font-size: 0.18rem; color: #299DFB; line-height: 0.3rem; cursor: pointer; font-weight: bold; position: relative;}
.serveboxmaxlist .wli6 .more div::after{ transition: all 0.5s; width: 0; height: 1px; background: #299DFB; position: absolute; bottom: 0; left: 50%; transform: translateX(-50%); content: '';}
.serveboxmaxlist .wli6 .more div:hover::after{ width: 80%;}
.serveboxmaxlist .wli6 .boot .li .m{ margin-bottom: 0.1rem; border-radius: 100%;}
.serveboxmaxlist .wli6 .toop .text .a{ margin-top: 1.2rem; background: #D1D4D7; color: #fff;}
.serveboxmaxlist .wli6 .toop .text .a:hover{ background: #333; color: #fff;}
.serveboxmaxlist{ padding: 0 0 0.8rem 0;}
.serveboxmaxlist .wli6 .boot .li .h{ transition: all 0.5s;}
.serveboxmaxlist .wli6 .boot .li:hover .h{ color: #299DFB;}



</style>